import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { resetPassEffect, verifyOtpEffect } from '../_effects';
import { alertActions } from './alertActions';

export const resetPassActions = {
  resetPass,
  validateOTP,
  resetMsg,
};

function resetMsg() {
  return (dispatch) => {
    dispatch(clearMsg());
  };
}

function clearMsg() {
  return { type: userConstants.CLEAR_RESET_PWD_MSG, payload: null };
}

function validateOTP(otp, payload) {
  return (dispatch) => {
    dispatch(requestValidity(otp));
    verifyOtpEffect.verifyOtpSet(otp).then(
      (res) => {
        if (res.data.statusCode == '402' || res.data.statusCode == '200') {
          dispatch(resetPass(payload));
        } else {
          dispatch(success(res));
        }
      },
      (error) => {
        console.log('action error', error);
        dispatch(failureValidity(error.toString()));
      }
    );
  };
}

function requestValidity(otp) {
  return { type: userConstants.VALIDATEOTP_REQUEST, otp };
}
function failureValidity(error) {
  return { type: userConstants.VALIDATEOTP_FAILURE, error };
}

function resetPass(pass) {
  return (dispatch) => {
    dispatch(request(pass));
    resetPassEffect.resetPassSet(pass).then(
      (pass) => {
        dispatch(success(pass));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
}

function request(pass) {
  return { type: userConstants.RESETPASS_REQUEST, pass };
}
function success(pass) {
  return { type: userConstants.RESETPASS_SUCCESS, pass };
}
function failure(error) {
  return { type: userConstants.RESETPASS_FAILURE, error };
}
